import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const processCODPayment = createAsyncThunk("payment/processCOD", async ({ orderId, navigate }, { fulfillWithValue, rejectWithValue }) => {
  try {
    // Primero confirmamos el pedido con la API
    await api.get(`/order/confirm/${orderId}`);
    // Redirigir a la página de confirmación
    navigate("/order/confirm", {
      state: {
        paymentMethod: "cod",
        orderId: orderId,
      },
    });

    return fulfillWithValue({
      orderId,
      paymentMethod: "cod",
      confirmed: true, // Nuevo campo para indicar confirmación exitosa
    });
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Error al procesar pago COD");
  }
});

const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    loading: false,
    error: null,
    currentOrder: null,
  },
  reducers: {
    resetPaymentState: state => {
      state.loading = false;
      state.error = null;
      state.currentOrder = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(processCODPayment.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(processCODPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.currentOrder = action.payload;
      })
      .addCase(processCODPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetPaymentState } = paymentSlice.actions;
export default paymentSlice.reducer;
